import { Link } from 'react-router-dom';
import './pages.css';

const Implants = () => {
    const products = [
                { name: 'FCZ Screw-Retained Hybrid Crown', path: '/products/implants/fczscrewretainedhybridcrown', image: '/images/implants/crown.webp' },
                { name: 'Titanium Abutment', path: '/products/implants/titaniumabutment', image: '/images/implants/titaniumabutment.webp' },
                { name: 'Zirconia Abutment', path: '/products/implants/zirconiaabutment', image: '/images/implants/zirconiaabutment.webp' },
                { name: 'Zirconia Hybrid  Implant Bridge', path: '/products/implants/zirconiahybridimplantbridge', image: '/images/implants/zirconiabridge.webp' }
            ];
        
        return (
            <div className="page fixed">
                {/* Hero Section */}
                <section className="products-hero-section">
                    <div className="products-hero-content">
                        <h1>Implants/Hybrid</h1>
                        <p className="products-tagline">Durable and esthetic dental solutions</p>
                    </div>
                </section>
    
                {/* Main Content */}
                <section className="products-content-section">
                    <div className="content-container">
                        {/* Intro Card */}
                        <div className="products-intro-card">
                            <p>
                                AbELab’s implant abutments and hybrids are fabricated with digital dentistry to ensure exceptional restorative results. Any of these solutions will provide your patient with optimal esthetics and lifelike function, as well as strength, stability, and durability. Our implant options are compatible with all major manufacturers, including Nobel Biocare®, Straumann®, and Zimmer Biomet.
                            </p>
                        </div>
    
                        {/* Products Grid */}
                        <div className="products-grid-enhanced">
                            {products.map((product, index) => (
                                <Link to={product.path} key={index} className="product-card-enhanced">
                                    <div className="product-image-wrapper">
                                        <img src={product.image} alt={product.name} />
                                    </div>
                                    <div className="product-info">
                                        <h3>{product.name}</h3>
                                        <span className="learn-more">Learn More →</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
};

export default Implants;